var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5616 16.5273H9.39801C8.97801 16.5273 8.63437 16.1837 8.63437 15.7637V3.54551C8.63437 3.12551 8.97801 2.78188 9.39801 2.78188H16.0846L19.3253 6.02256V15.7637C19.3253 16.1837 18.9816 16.5273 18.5616 16.5273ZM9.39801 18.8182H18.5616C20.2464 18.8182 21.6162 17.4485 21.6162 15.7637V6.02256C21.6162 5.41642 21.3728 4.83415 20.9432 4.4046L17.7073 1.16392C17.2778 0.734376 16.6955 0.490967 16.0894 0.490967H9.39801C7.71324 0.490967 6.34347 1.86074 6.34347 3.54551V15.7637C6.34347 17.4485 7.71324 18.8182 9.39801 18.8182ZM3.28892 6.60006C1.60415 6.60006 0.234375 7.96983 0.234375 9.6546V21.8728C0.234375 23.5576 1.60415 24.9273 3.28892 24.9273H12.4526C14.1373 24.9273 15.5071 23.5576 15.5071 21.8728V20.3455H13.2162V21.8728C13.2162 22.2928 12.8726 22.6364 12.4526 22.6364H3.28892C2.86892 22.6364 2.52528 22.2928 2.52528 21.8728V9.6546C2.52528 9.2346 2.86892 8.89097 3.28892 8.89097H4.81619V6.60006H3.28892Z",
    fill: "#007BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopy);
export default __webpack_public_path__ + "static/media/icon-copy.ffcaed8e799752a773c2d9d1cbd7c195.svg";
export { ForwardRef as ReactComponent };